/* eslint-disable max-len */
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';

import { MatCard, MatCardContent } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogActions } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrAdvisorRelationshipsSelectorModule } from '@next/core-lib/advisor-relationships-selector';
import {
  AgrNotificationEmptyModule,
  AgrPageDetailModule,
  AgrResponsiveActionsModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AdviceComponent } from './advice.component';
import { CopyAdviceModule } from '../copy-advice/copy-advice.module';
import { EnvironmentalImpactModule } from '../environmental-impact/environmental-impact.module';
import { LegalStandardModule } from '../legal-standard/legal-standard.module';

import { OrganicMatterModule } from '../organic-matter/organic-matter.module';
import { SharedModule } from '../shared/shared.module';
import { EditFertilizationBalanceSettingsDialogComponent } from './components/edit-fertilization-balance-settings-dialog/edit-fertilization-balance-settings-dialog.component';
import { SelectCropFieldsDialogComponent } from '../shared/components/select-cropfields-dialog/select-cropfields-dialog.component';
import { SoilAnalysisModule } from '../soil-analysis/soil-analysis.module';
import { CompanySettingsDialogComponent } from './components/company-settings-dialog/company-settings-dialog.component';
import { CopyAdviceConfirmationDialogComponent } from './components/copy-advice-confirmation-dialog/copy-advice-confirmation-dialog.component';
import { EditAllFertilizationSettingsDialogComponent } from './components/edit-all-fertilization-settings-dialog/edit-all-fertilization-settings-dialog.component';
import { FertilizationSettingDetailComponent } from './components/edit-all-fertilization-settings-dialog/fertilization-setting-detail/fertilization-setting-detail.component';
import { FertilizationBalanceSettingDetailComponent } from './components/edit-fertilization-balance-settings-dialog/fertilization-balance-setting-detail/fertilization-balance-setting-detail.component';
import { FertilizationBalanceSettingsCancellationConfirmDialogComponent } from './components/edit-fertilization-balance-settings-dialog/fertilization-balance-settings-cancellation-confirm-dialog/fertilization-balance-settings-cancellation-confirm-dialog.component';
import { FertilizationBalanceSettingsParticipationConfirmDialogComponent } from './components/edit-fertilization-balance-settings-dialog/fertilization-balance-settings-participation-confirm-dialog/fertilization-balance-settings-participation-confirm-dialog.component';
import { SpecificReferenceBlockDialogComponent } from './components/edit-fertilization-balance-settings-dialog/specific-reference-block-dialog/specific-reference-block-dialog.component';
import { FertilizationSettingDialogComponent } from './components/fertilization-setting-dialog/fertilization-setting-dialog.component';
import { GreenManureSettingsComponent } from './components/fertilization-setting-dialog/green-manure-settings/green-manure-settings.component';
import { NitrogenCalculationSettingsComponent } from './components/fertilization-setting-dialog/nitrogen-calclulation-settings/nitrogen-calculation-settings.component';
import { PrecedingCropSettingsComponent } from './components/fertilization-setting-dialog/preceding-crop-settings/preceding-crop-settings.component';
import { LegalRestrictionInfoComponent } from './components/legal-restriction-info/legal-restriction-info.component';
import { SelectCustomerDialogComponent } from './components/select-customer-dialog/select-customer-dialog.component';
import { SkalReportQuickViewComponent } from './components/skal-report-quick-view/skal-report-quick-view.component';
import { TreatmentDialogComponent } from './components/treatment-dialog/treatment-dialog.component';
import { AdviceEffects } from './store/effects';
import { adviceReducer } from './store/reducer';

@NgModule({
  declarations: [
    TreatmentDialogComponent,
    FertilizationSettingDialogComponent,
    EditAllFertilizationSettingsDialogComponent,
    FertilizationSettingDetailComponent,
    GreenManureSettingsComponent,
    PrecedingCropSettingsComponent,
    AdviceComponent,
    LegalRestrictionInfoComponent,
    NitrogenCalculationSettingsComponent,
    SkalReportQuickViewComponent,
    SelectCustomerDialogComponent,
    CopyAdviceConfirmationDialogComponent,
    SelectCropFieldsDialogComponent,
    CompanySettingsDialogComponent,
    EditFertilizationBalanceSettingsDialogComponent,
    FertilizationBalanceSettingDetailComponent,
    FertilizationBalanceSettingsCancellationConfirmDialogComponent,
    FertilizationBalanceSettingsParticipationConfirmDialogComponent,
    SpecificReferenceBlockDialogComponent,
  ],
  imports: [
    SharedModule,
    OverlayModule,
    LegalStandardModule,
    SoilAnalysisModule,
    OrganicMatterModule,
    EnvironmentalImpactModule,
    AgrPageDetailModule,
    AgrFormModule,
    AgrNotificationEmptyModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatDialogActions,
    MatChipsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    AgrDialogModule,
    AgrValueRowModule,
    AgrResponsiveActionsModule,
    FormsModule,
    ReactiveFormsModule,
    LetDirective,
    PushPipe,
    CopyAdviceModule,
    AgrAdvisorRelationshipsSelectorModule,
    MatCard,
    MatCardContent,
    MatTooltipModule,
  ],
  providers: [provideState('advice', adviceReducer), provideEffects(AdviceEffects)],
})
export class AdviceModule {}
